import { request, mcRequest } from "../utils";

export const getMerchantContacts = () => request(`/system/customer-service/contacts`);
